import { useEffect } from 'react';

type IProps = {
    keyCap: string;
    metaKey?: boolean;
    ctrlKey?: boolean;
    shiftKey?: boolean;
    altKey?: boolean;
    callbackFunc: () => void;
};

const useKeyboardKeys = ({
    keyCap,
    metaKey = false,
    ctrlKey = false,
    shiftKey = false,
    altKey = false,
    callbackFunc,
}: IProps) => {
    useEffect(() => {
        const down = (e: KeyboardEvent) => {
            const isMatch =
                e.key.toLowerCase() === keyCap.toLowerCase() &&
                (e.metaKey === metaKey || e.ctrlKey === ctrlKey) &&
                e.shiftKey === shiftKey &&
                e.altKey === altKey;

            if (isMatch) {
                e.preventDefault();
                callbackFunc();
            }
        };

        document.addEventListener('keydown', down);
        return () => document.removeEventListener('keydown', down);
    }, [keyCap, metaKey, ctrlKey, shiftKey, altKey, callbackFunc]);

    return null;
};

export default useKeyboardKeys;
